import styled from '@emotion/styled';
import RotateIcon from 'assets/icons/rotate.svg';
import {
  BOUNDING_BOX_COLORS_PRIMARY,
  ROTATION_CURSOR_EXTRA_MARGIN_TOP_PX,
  ROTATION_CURSOR_MARGIN_TOP_PX,
  baseBoundingBoxCssStyle,
} from 'constants/bounding-box';
import Moveable from 'react-moveable';

type StyledMoveableType = {
  activeGroupIdx: number;
  isGroup: boolean;
  showControls: boolean;
  showDragControl: boolean;
  invisibleBoundingBox?: boolean;
  positionLowerDragResizeControl: boolean;
};

export const StyledMoveable = styled(Moveable)<StyledMoveableType>`
  // Override the z-index of Moveable so that it appears below Chakra modals
  z-index: var(--vg-zIndices-boundingBox) !important;
  // Nested bounding boxes
  .moveable-control-box {
    .moveable-line,
    .moveable-direction {
      height: 0.5px;
    }

    .moveable-control-box {
      .moveable-line,
      .moveable-direction {
        height: 1px;
        background: ${BOUNDING_BOX_COLORS_PRIMARY};
      }
    }
  }
  .moveable-line.moveable-edge.moveable-direction {
    background: ${(props) => (props.invisibleBoundingBox ? 'transparent' : BOUNDING_BOX_COLORS_PRIMARY)};
  }
  ${baseBoundingBoxCssStyle}
  //  Active nested bounding box
  .moveable-control-box:nth-of-type(${(props) => props.activeGroupIdx + 1}) {
    .moveable-line,
    .moveable-direction {
      height: 2px;
    }
  }
  // disable pointer events for groups - this is needed for the bounding box to be clickable
  .moveable-area {
    pointer-events: ${(props) => (props.isGroup ? 'none' : 'auto')};
  }
  // custom style for the rotation control
  .moveable-rotation-control {
    opacity: ${(props) => (props.showControls ? '0' : '')};
    margin-left: ${(props) => (props.showDragControl ? '6px !important' : '-12px !important')};
    margin-top: ${(props) =>
      props.positionLowerDragResizeControl
        ? `${ROTATION_CURSOR_EXTRA_MARGIN_TOP_PX}px !important`
        : `${ROTATION_CURSOR_MARGIN_TOP_PX}px !important`};
    width: 24px !important;
    height: 24px !important;
    border-width: 0px !important;
    box-shadow: 0 0 4px 1px rgb(57 76 96 / 15%), 0 0 0 1px rgb(47 64 80 / 25%) !important;
    background-image: url('${RotateIcon}') !important;
    background-repeat: no-repeat !important;
    background-position: center !important;
    transition: background-color 0.1s linear;
  }
  .moveable-rotation-control:hover {
    background-color: var(--vg-colors-gray-100) !important;
  }
  .moveable-rotation-line {
    display: none !important;
  }
`;
